// removed by extract-text-webpack-plugin
module.exports = {"date":"_1qp1XbFPLiLciTYi6Xem-5","intro":"_1ZcdpOMMaRSxqUoMh9Do01","photos":"_8Nr4Nc_udL6kOa-DZBExb"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/SuburbanCamps/SuburbanCamps.scss
// module id = 339
// module chunks = 0